module.exports = __webpack_public_path__ + "_/src/containers/status_embed/position_preview_app-75ab3740f639e314d488293059b74866.svg";